export default __webpack_public_path__ + "static/media/sparkle.c9da9be8.mp4";